<div class="spinner">
  <svg-icon key="mini/spinner"></svg-icon>
</div>
